export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}


export function get_date(n,flag){//获取当前日期后n天
  // 获取日期函数，若gap=0,则为系统日期，若不为0，则当期日期+n(待参考)
    let date = new Date();
    date = date.getTime() + 1000*60*60*24*n;
    let temp = new Date();
    temp.setTime(date);
    let day = format_date(temp,flag);
    return day;
}

export function get_date2(n){//获取当前日期后n天 的年，月，日
  // 获取日期函数，若gap=0,则为系统日期，若不为0，则当期日期+n(待参考)
  let date = new Date();
  date = date.getTime() + 1000*60*60*24*n;
  let temp = new Date();
  temp.setTime(date);
  let day = format_date2(temp);
  return day;
}



function format_date(DateFor,flag){//全局函数1
  let year = DateFor.getFullYear();
  let month = DateFor.getMonth()+1;
  let day = DateFor.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (day >= 0 && day <= 9) {
    day = "0" + day;
  }
  let tmp = '';
  if(flag=='1'){
    tmp= year + '年'+ month + '月' + day+ '日';
  }else if(flag=='2'){
    tmp= month + '月' + day+ '日';
  }else if(flag=='3'){
    tmp= year + '-'+ month + '-' + day+ '-';
  }
  return tmp
}

function format_date2(DateFor){//获取年月日
  let date = {};
  let year = DateFor.getFullYear();
  let month = DateFor.getMonth();
  let day = DateFor.getDate();
  date.year = year;
  date.month = month;
  date.day = day;
  return date
}

export function getDateDetail(startDate,endDate,limitDay){
  console.log('门票的有效起期：'+ startDate +',门票的有效止期：'+endDate+',limitDay：'+limitDay);
  let data = {};
  let date1 = new Date(startDate.replace(/-/g, '/'));
  let date2 = new Date(endDate.replace(/-/g, '/'));
  let validStartDate = '';
  let validEndDate = '';
  if(new Date().getTime()<date1.getTime()){
    if(getTimeByLimitDay(limitDay)<date1.getTime()){
      validStartDate = date1.getTime();
      validEndDate = date2.getTime();
    }else if(date1.getTime()<=getTimeByLimitDay(limitDay) && getTimeByLimitDay(limitDay)<=date2.getTime()){
      validStartDate = getTimeByLimitDay(limitDay);
      validEndDate = date2.getTime();
    }else{
      validStartDate = '';
      validEndDate ='';
    }
  }else if(date1.getTime()<=new Date().getTime() && new Date().getTime()<=date2.getTime()){
    if(date1.getTime()<getTimeByLimitDay(limitDay) && getTimeByLimitDay(limitDay)<=date2.getTime()){
      validStartDate = getTimeByLimitDay(limitDay);
      validEndDate = date2.getTime();
    }else{
      validStartDate = '';
      validEndDate = '';
    }
  }else {
    validStartDate = '';
    validEndDate = '';
  }
  if(validStartDate==''||validEndDate==''){
    data.date = '';
    data.D1 = false;
    data.D2 = false;
    data.D3 = false;
    data.MORE = false;
    return data
  }
  let n = (validEndDate-validStartDate)/1000/60/60/24;
  n = Math.floor(n);
  if(n==0){
    console.log("1111111111:"+n);
    let temp1 = new Date();
    temp1.setTime(validStartDate);
    data.date = format_date(temp1,1);
    data.date1 = format_date(temp1,1);
    data.D1 = true;
    data.D2 = false;
    data.D3 = false;
    data.MORE = false;
  }else if(n==1){
    console.log("22222222:"+n);
    let temp1 = new Date();
    let temp2 = new Date();
    temp1.setTime(validStartDate);
    temp2.setTime(validStartDate+1000*60*60*24*1);
    data.date = format_date(temp1,1);
    data.date1 = format_date(temp1,1);
    data.date2 = format_date(temp2,1);
    data.D1 = true;
    data.D2 = true;
    data.D3 = false;
    data.MORE = false;
  }else if(n==2){
    console.log("333333333333:"+n);
    let temp1 = new Date();
    let temp2 = new Date();
    let temp3 = new Date();
    temp1.setTime(validStartDate);
    temp2.setTime(validStartDate+1000*60*60*24*1);
    temp3.setTime(validStartDate+1000*60*60*24*2);
    data.date = format_date(temp1,1);
    data.date1 = format_date(temp1,1);
    data.date2 = format_date(temp2,1);
    data.date3 = format_date(temp3,1);
    data.D1 = true;
    data.D2 = true;
    data.D3 = true;
    data.MORE = false;
  }else if(n>=3 && n<=9){
    console.log("4444444444:"+n);
    let temp1 = new Date();
    let temp2 = new Date();
    let temp3 = new Date();
    temp1.setTime(validStartDate);
    temp2.setTime(validStartDate+1000*60*60*24*1);
    temp3.setTime(validStartDate+1000*60*60*24*2);
    data.date = format_date(temp1,1);
    data.date1 = format_date(temp1,1);
    data.date2 = format_date(temp2,1);
    data.date3 = format_date(temp3,1);
    data.D1 = true;
    data.D2 = true;
    data.D3 = true;
    data.MORE = true;
    let temp4 = new Date();
    let temp5 = new Date();
    temp4.setTime(validStartDate+1000*60*60*24*3);
    temp5.setTime(validStartDate+1000*60*60*24*n);
    data.minyear = format_date2(temp4).year;
    data.minmonth = format_date2(temp4).month;
    data.minday = format_date2(temp4).day;
    data.maxyear = format_date2(temp5).year;
    data.maxmonth = format_date2(temp5).month;
    data.maxday = format_date2(temp5).day;
  }else{
    console.log("5555555:"+n);
    let temp1 = new Date();
    let temp2 = new Date();
    let temp3 = new Date();
    temp1.setTime(validStartDate);
    temp2.setTime(validStartDate+1000*60*60*24*1);
    temp3.setTime(validStartDate+1000*60*60*24*2);
    data.date = format_date(temp1,1);
    data.date1 = format_date(temp1,1);
    data.date2 = format_date(temp2,1);
    data.date3 = format_date(temp3,1);
    data.D1 = true;
    data.D2 = true;
    data.D3 = true;
    data.MORE = true;
    let temp4 = new Date();
    let temp5 = new Date();
    temp4.setTime(validStartDate+1000*60*60*24*3);
    temp5.setTime(validStartDate+1000*60*60*24*9);
    data.minyear = format_date2(temp4).year;
    data.minmonth = format_date2(temp4).month;
    data.minday = format_date2(temp4).day;
    data.maxyear = format_date2(temp5).year;
    data.maxmonth = format_date2(temp5).month;
    data.maxday = format_date2(temp5).day;
  }
  console.log("data:   "+ JSON.stringify(data));
  return data;
}

function getTimeByLimitDay(n){//获取当前时间n天后的时间戳
  let date = new Date();
  date = date.getTime() + 1000*60*60*24*n;
  return date;
}






// WEBPACK FOOTER //
// ./src/common/js/date.js